export default __webpack_public_path__ + "static/media/2122 knife block A top.da3ab715.png";